var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVkMobileHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 13,
  viewBox: "0 0 15 13",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7.5 13S15 7.982 15 3.627c0-.853-.803-3.599-3.742-3.599C8.674.028 7.5 2.15 7.5 2.15S6.469 0 4.087 0C1 0 0 2.828 0 3.627 0 8.307 7.5 13 7.5 13"
})));
export default SvgVkMobileHeart;